import React, { useContext } from "react";

//material ui
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

//styling
import "../../Styles/apiKeyModal.scss";

//global state
import { StateContext } from "../../AppStateContext";

const ApiKeyModal = ({ sandboxId, apiKey, open = false, closeFn }) => {
  const handleClose = closeFn;

  //global state
  const state = useContext(StateContext);

  return (
    <>
      <Modal
        disableScrollLock
        aria-labelledby="WCS enterprise token modal"
        aria-describedby="copy the token to your clipboard "
        className="__apiKeyOuter"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            className={
              state.theme === "dark"
                ? "__apiKeyModal __apiKeyModalDark"
                : "__apiKeyModal __apiKeyModalLight"
            }
          >
            <h2>Authorization API key</h2>
            <p className="__apiKeyClusterId">
              <span>Sandbox ID:</span>
              <span>{sandboxId}</span>
            </p>
            <p>
              This is the API key for your sandbox. Pass it via the
              "Authorization" header as a Bearer token to authenticate.
            </p>
            <p className="__apiKeyExampleWrapper">
              <span>Example:</span>
              <span className="__apiKeyExample">Authorization: Bearer {apiKey}</span>
            </p>
            <button onClick={handleClose}>Close</button>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default ApiKeyModal;
